module.exports = __webpack_public_path__ + "static/img/industry_icon3.42d1cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/industry_icon3.png
// module id = r8+U
// module chunks = 0